export default __webpack_public_path__ + "static/media/webdev.8e3cfee7.png";